import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon, DatePicker, SelectMenu, toast, BackdropLoader, getUtility, ExpandedTooltip } from '@livable/saas-react-components';
import { Alert, Button, Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText, InputAdornment, InputLabel, MenuItem, OutlinedInput, TextField, ToggleButton, ToggleButtonGroup, Typography, IconButton } from '@mui/material';
import { observer } from 'mobx-react-lite';
import moment from 'moment/moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { USER_ROLES_BY_NAME, USER_SETTINGS_KEYS } from 'src/constants/userSetting';
import { useStore } from 'src/stores';
import useStyles from './styles';
import useModalFooterStyles from 'src/styles/cutomModalFooter';
export const BatchPostChargeModalContent = observer(_ref => {
  var _store$homeDashboardS;
  let handleModalClose = _ref.handleModalClose;
  const store = useStore();
  const classes = useStyles();
  const history = useLocation();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const modalFooterClasses = useModalFooterStyles();
  const showAdminFee = USER_ROLES_BY_NAME[localStorage.getItem(USER_SETTINGS_KEYS.userRole)] === USER_ROLES_BY_NAME.LivableAdmin || USER_ROLES_BY_NAME[localStorage.getItem(USER_SETTINGS_KEYS.userRole)] === USER_ROLES_BY_NAME.LivableSuperAdmin || store.userRole === USER_ROLES_BY_NAME.LivableAdmin || store.userRole === USER_ROLES_BY_NAME.LivableSuperAdmin;
  const titleMaxLength = 60;
  const repeatOn = 'OnStatementIssued';
  const params = new URLSearchParams(history.search);
  const propertyId = params.get('id') || ((_store$homeDashboardS = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.id) || store.residenciesMultiActionStore.isSelectedIsMultiPropertyView && store.residenciesMultiActionStore.isSelectedFromSingleProperty && store.residenciesMultiActionStore.selectedDetails[0].propertyId || null;
  const _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isReview = _useState2[0],
    setIsReview = _useState2[1];
  const _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    utilities = _useState4[0],
    setUtilities = _useState4[1];
  const _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    note = _useState6[0],
    setNote = _useState6[1];
  const _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    memo = _useState8[0],
    setMemo = _useState8[1];
  const _useState9 = useState(''),
    _useState0 = _slicedToArray(_useState9, 2),
    amount = _useState0[0],
    setAmount = _useState0[1];
  const _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    amountTouched = _useState10[0],
    setAmountTouched = _useState10[1];
  const _useState11 = useState(''),
    _useState12 = _slicedToArray(_useState11, 2),
    title = _useState12[0],
    setTitle = _useState12[1];
  const _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    titleTouched = _useState14[0],
    setTitleTouched = _useState14[1];
  const _useState15 = useState('charge'),
    _useState16 = _slicedToArray(_useState15, 2),
    chargeType = _useState16[0],
    setChargeType = _useState16[1];
  const _useState17 = useState('OneTime'),
    _useState18 = _slicedToArray(_useState17, 2),
    postType = _useState18[0],
    setPostType = _useState18[1];
  const _useState19 = useState(moment().toDate()),
    _useState20 = _slicedToArray(_useState19, 2),
    chosenDate = _useState20[0],
    setChosenDate = _useState20[1];
  const _useState21 = useState(null),
    _useState22 = _slicedToArray(_useState21, 2),
    customChargeOnDate = _useState22[0],
    setCustomChargeOnDate = _useState22[1];
  const _useState23 = useState('Charge on date'),
    _useState24 = _slicedToArray(_useState23, 2),
    datePickerLabel = _useState24[0],
    setDatePickerLabel = _useState24[1];
  const _useState25 = useState(null),
    _useState26 = _slicedToArray(_useState25, 2),
    defaultChargeOnDateValue = _useState26[0],
    setDefaultChargeOnDateValue = _useState26[1];
  const getLabel = () => {
    if (customChargeOnDate) return 'Charge on date';else if (defaultChargeOnDateValue) return moment(defaultChargeOnDateValue).format('MM/DD/YYYY');
    return 'Charge on date';
  };

  // NOTE: hide it until BE for charge on date  would be ready
  /*
  const [customChargeOnDate, setCustomChargeOnDate] = useState(null);
  const [isSuccessCustomChargeOnDate, setIsSuccessCustomChargeOnDate] = useState(false);
   const updateChargeOnDate = async chargeOnDate => {
    if (!store.company.companyFeatureStore.isAppfolio) return;
    if (isSuccessCustomChargeOnDate) {
      toast('success', { body: [t('Bill charge on date updated!'), chargeOnDate] });
      setIsSuccessCustomChargeOnDate(false);
    } else {
      toast('error', { body: [t('While updating bill charge on date!'), chargeOnDate] });
      setIsSuccessCustomChargeOnDate(true);
    }
  };
    */

  const _useState27 = useState('month'),
    _useState28 = _slicedToArray(_useState27, 2),
    occurancy = _useState28[0],
    setOccurancy = _useState28[1];
  const handleOccurancyChange = (e, value) => {
    if (value) setOccurancy(value);
  };
  const _useState29 = useState('OnMoveOut'),
    _useState30 = _slicedToArray(_useState29, 2),
    ends = _useState30[0],
    setEnds = _useState30[1];
  const handleEndsChange = (e, value) => {
    if (value) setEnds(value);
  };
  const _useState31 = useState(false),
    _useState32 = _slicedToArray(_useState31, 2),
    notifyResident = _useState32[0],
    setNotifyResident = _useState32[1];
  const _useState33 = useState(1),
    _useState34 = _slicedToArray(_useState33, 2),
    numberOfOccurrences = _useState34[0],
    setNumberOfOccurrences = _useState34[1];
  const _useState35 = useState('Miscellaneous'),
    _useState36 = _slicedToArray(_useState35, 2),
    transactionType = _useState36[0],
    setTransactionType = _useState36[1];
  const _useState37 = useState(moment().toDate()),
    _useState38 = _slicedToArray(_useState37, 2),
    repeatingMonth = _useState38[0],
    setRepeatingMonth = _useState38[1];
  const handleStartDate = _ref2 => {
    let date = _ref2.date;
    setRepeatingMonth(moment(date).toDate());
  };
  const handlePostTypeChange = (e, value) => {
    setPostType(value);
    if (value === 'recurring') {
      setTransactionType('Miscellaneous');
      setNotifyResident(false);
    }
  };
  const getUtilities = async () => {
    var _resp$response;
    if (!propertyId) return;
    const cData = [];
    const resp = await store.properties.getPropertyUtilityProvidersV3Async.run({
      propertyId
    });
    resp === null || resp === void 0 || (_resp$response = resp.response) === null || _resp$response === void 0 || _resp$response.map(item => {
      const cSubItem = {
        providerName: item.utilityProviderName,
        utilities: []
      };
      item.utilities.map(u => {
        cSubItem.utilities.push({
          name: u.utilityType,
          utilityId: u.utilityId,
          propertyUtilityId: u.id
        });
      });
      cData.push(cSubItem);
    });
    setUtilities(cData);
  };
  const getChargeOnDate = async () => {
    await store.allocations.getCurrentCycleAsync.run({
      companyId: localStorage.getItem(USER_SETTINGS_KEYS.company)
    });
    await store.appfolioPropertiesApi.getDefaultChargeOnDateAsync.run({
      propertyId,
      allocationCycleMonth: store.allocations.currentCycle.month,
      allocationCycleYear: store.allocations.currentCycle.year
    }).then(getSettingsByBillIdAsyncResp => {
      if (getSettingsByBillIdAsyncResp !== null && getSettingsByBillIdAsyncResp !== void 0 && getSettingsByBillIdAsyncResp.isSuccessful) {
        setDefaultChargeOnDateValue(getSettingsByBillIdAsyncResp.response);
        setDatePickerLabel("Charge on date will be set to ".concat(moment(getSettingsByBillIdAsyncResp.response).format('MM/DD/YYYY')));
      }
    });
  };
  useEffect(() => {
    getUtilities();
    if (store.company.companyFeatureStore.isAppfolio) getChargeOnDate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleSubmit = async () => {
    const data = {
      propertyId: propertyId === null ? undefined : propertyId,
      userAccountIds: [],
      customCharge: null,
      customCredit: null,
      scheduledTransaction: null
    };
    if (store.residenciesMultiActionStore.isSelectedIsMultiPropertyView && !store.residenciesMultiActionStore.isSelectedFromSingleProperty) {
      delete data.propertyId;
      delete data.userAccountIds;
      data.propertyAccountIds = store.residenciesMultiActionStore.selectedDetails.reduce((acc, cur) => {
        if (acc.findIndex(i => i.propertyId === cur.propertyId) === -1) {
          acc.push({
            propertyId: cur.propertyId,
            userAccountIds: [cur.accountId]
          });
        } else if (acc.findIndex(i => i.propertyId === cur.propertyId) !== -1) {
          acc[acc.findIndex(i => i.propertyId === cur.propertyId)].userAccountIds.push(cur.accountId);
        }
        return acc;
      }, []);
    } else {
      store.residenciesMultiActionStore.selectedDetails.map(i => {
        data.userAccountIds.push(i.accountId);
      });
    }
    const subData = {
      amount: +amount,
      memo: memo,
      notes: note,
      title: title
    };
    if (store.company.companyFeatureStore.isAppfolio) subData.appfolioChargeOnDate = customChargeOnDate;
    if (postType === 'recurring') {
      subData.monthlyRepeatCondition = repeatOn;
      subData.postType = chargeType;
      subData.repeatRate = occurancy;
      if (occurancy === 'month') {
        subData.repeatOnMonth = null;
      } else {
        subData.repeatOnMonth = moment(repeatingMonth).format('M') || 1;
      }
      subData.endingCondition = ends;
      subData.endingDateOnly = null;
      subData.endingNumberOfOccurrences = null;
      subData.occuredTimes = null;
      if (ends === 'OnDate') {
        subData.endingDateOnly = moment(chosenDate).format(moment.HTML5_FMT.DATE);
      } else if (ends === 'OnNumberOfOccurrences') {
        subData.endingNumberOfOccurrences = +numberOfOccurrences;
        subData.occuredTimes = +numberOfOccurrences;
      }
      if (transactionType === 'Miscellaneous') subData.transactionType = 'Miscellaneous';else if (transactionType === 'AdminFee') subData.transactionType = 'AdminFee';else subData.transactionType = 'Utility';
      data.scheduledTransaction = subData;
    } else {
      if (transactionType === 'Miscellaneous') subData.type = 'Miscellaneous';else if (transactionType === 'AdminFee') subData.type = 'AdminFee';else subData.type = 'Utility';
      subData.utilityId = transactionType === 'Miscellaneous' || transactionType === 'AdminFee' ? null : transactionType.utilityId;
      subData.propertyUtilityId = transactionType === 'Miscellaneous' || transactionType === 'AdminFee' ? null : transactionType.propertyUtilityId;
      subData.notifyResident = notifyResident;
      if (chargeType === 'charge') {
        data.customCharge = subData;
      } else {
        data.customCredit = subData;
      }
    }
    const resp = await store.transaction.customTransactionsAsync.run(data);
    setIsReview(true);
    if (resp && resp.isSuccessful) {
      var _store$homeDashboardS2, _store$homeDashboardS3;
      toast('success', {
        body: ['Successfully posted']
      });
      store.residencies.toggleRefreshFlag(true);
      (_store$homeDashboardS2 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS2 === void 0 || (_store$homeDashboardS2 = _store$homeDashboardS2.companyResidentsTabOptions) === null || _store$homeDashboardS2 === void 0 || _store$homeDashboardS2.updateModel({
        refreshResidentsFlag: !((_store$homeDashboardS3 = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS3 !== void 0 && (_store$homeDashboardS3 = _store$homeDashboardS3.companyResidentsTabOptions) !== null && _store$homeDashboardS3 !== void 0 && _store$homeDashboardS3.refreshResidentsFlag)
      });
      store.residenciesMultiActionStore.deselectAll();
      handleModalClose();
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, isReview && /*#__PURE__*/React.createElement("div", {
    className: classes.modalContent
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    className: classes.title
  }, postType === 'recurring' ? t('post_charge_modal.recurring_typed_title', {
    type: chargeType
  }) : t('post_charge_modal.typed_title', {
    type: chargeType
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('post_charge_modal.title'),
    variant: "outlined",
    value: title,
    fullWidth: true,
    onBlur: () => {
      if (!titleTouched) setTitleTouched(true);
    },
    onChange: e => {
      if (e.target.value.length <= titleMaxLength) setTitle(e.target.value);
    },
    error: titleTouched && !title.trim().length,
    helperText: titleTouched && !title.trim().length && 'Title is required.'
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.counter, " ").concat(titleTouched && !title.trim().length ? classes.counterError : '')
  }, "(", title.length, "/", titleMaxLength, ")")), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('post_charge_modal.what_to_post')), /*#__PURE__*/React.createElement("div", {
    className: classes.typeBlock
  }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    value: chargeType,
    onChange: (e, value) => setChargeType(value),
    exclusive: true
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: "charge"
  }, t('post_charge_modal.charge')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "credit"
  }, t('post_charge_modal.credit'))), /*#__PURE__*/React.createElement(SelectMenu, {
    id: "type",
    label: "Type",
    labelId: "type-label",
    onChange: e => {
      if (e.target.value !== 'headerName') setTransactionType(e.target.value);
    },
    value: transactionType
  }, postType === 'OneTime' ? utilities.map(utility => {
    const currentItems = [{
      isTitle: true,
      providerName: utility.providerName
    }, ...utility.utilities];
    return currentItems.map((item, index) => {
      return item.isTitle ? /*#__PURE__*/React.createElement(MenuItem, {
        key: item.providerName + '_' + index,
        id: item.providerName,
        className: classes.chargeCreditTypeHeader,
        value: 'headerName',
        onClick: event => event.stopPropagation()
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "body2",
        component: 'span'
      }, item.providerName)) : /*#__PURE__*/React.createElement(MenuItem, {
        key: item.utilityId,
        value: item,
        className: classes.chargeCreditType
      }, getUtility(item.name).icon(), " ", item.name);
    });
  }) : null, /*#__PURE__*/React.createElement(MenuItem, {
    key: 'other_header',
    id: 'other_header',
    className: classes.chargeCreditTypeHeader,
    value: 'headerName',
    onClick: event => event.stopPropagation()
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "disabled",
    component: 'span'
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    component: 'span'
  }, 'Other'))), showAdminFee ? /*#__PURE__*/React.createElement(MenuItem, {
    className: classes.chargeCreditType,
    key: 'AdminFee',
    id: 'AdminFee',
    value: "AdminFee"
  }, "Admin Fee") : null, /*#__PURE__*/React.createElement(MenuItem, {
    key: 'Miscellaneous',
    id: 'Miscellaneous',
    value: "Miscellaneous",
    className: classes.chargeCreditType
  }, t('post_charge_modal.miscellaneous')))), /*#__PURE__*/React.createElement("div", {
    className: classes.lgSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('post_charge_modal.post_type'))), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    value: postType,
    onChange: handlePostTypeChange,
    exclusive: true
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: "OneTime"
  }, t('post_charge_modal.one_time')), !store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement(ToggleButton, {
    value: "recurring"
  }, t('post_charge_modal.recurring')))), postType === 'recurring' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('post_charge_modal.repeat_every'), " ", t('post_charge_modal.will_be_posted'))), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    size: "small",
    value: occurancy,
    onChange: handleOccurancyChange,
    exclusive: true
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: "month"
  }, t('post_charge_modal.month')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "year"
  }, t('post_charge_modal.year'))), occurancy === 'year' && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.datePicker, " ").concat(classes.smSection)
  }, /*#__PURE__*/React.createElement(DatePicker, {
    label: t('post_charge_modal.month'),
    format: "MMMM",
    value: repeatingMonth,
    onChange: date => handleStartDate({
      date
    }),
    showMonthYearPicker: true,
    minDate: moment().toDate()
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('post_charge_modal.ends'))), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    size: "small",
    value: ends,
    onChange: handleEndsChange,
    exclusive: true
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: "OnMoveOut"
  }, t('post_charge_modal.on_move_out')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "OnDate"
  }, t('post_charge_modal.on_date')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "OnNumberOfOccurrences"
  }, t('post_charge_modal.after_occurences')))), ends === 'OnDate' && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.datePicker, " ").concat(classes.smSection)
  }, /*#__PURE__*/React.createElement(DatePicker, {
    value: chosenDate,
    onChange: date => setChosenDate(date),
    format: "MM/dd/yy",
    minDate: moment().toDate()
  })), ends === 'OnNumberOfOccurrences' && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.smSection, " ").concat(classes.smallField)
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('post_charge_modal.num_of_occurances'),
    variant: "outlined",
    fullWidth: true,
    type: "number",
    value: numberOfOccurrences,
    onKeyPress: event => {
      if (!/^[+-]?\d+(\.\d+)?$/.test(event.key)) event.preventDefault();
    },
    onChange: e => {
      if (!/^\d+([.,]\d{0,2})?$|^$/.test(e.target.value)) return;
      setNumberOfOccurrences(e.target.value);
    },
    error: !numberOfOccurrences,
    helperText: !numberOfOccurrences && 'Field is required.'
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.lgSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('general.details'))), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(FormControl, {
    className: classes.smallField,
    onKeyPress: event => {
      if (!/[0-9]|[.,]/.test(event.key)) {
        event.preventDefault();
      }
    },
    onChange: e => {
      if (!/^\d+([.,]\d{0,2})?$|^$/.test(e.target.value)) return;
      setAmount(e.target.value);
    },
    variant: "outlined",
    error: amountTouched && amount.length === 0
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "amount"
  }, t('post_charge_modal.enter_amount')), /*#__PURE__*/React.createElement(OutlinedInput, {
    id: "amount",
    label: t('post_charge_modal.enter_amount'),
    placeholder: "0.00",
    startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "start"
    }, "$"),
    type: "number",
    value: amount,
    onBlur: () => {
      if (!amountTouched) setAmountTouched(true);
    }
  }), amountTouched && amount.length === 0 && /*#__PURE__*/React.createElement(FormHelperText, null, "It should be a number and greater than 0"))), store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.customChargeOnDateDatePicker, " ").concat(classes.actionsBar)
  }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    placement: 'top',
    title: customChargeOnDate ? '' : datePickerLabel,
    type: 'success-bold-dark'
  }, /*#__PURE__*/React.createElement(DatePicker, {
    format: "MM/dd/yyyy",
    label: getLabel(),
    onChange: date => {
      const formatedDate = date === null || date === '' ? null : moment(date).format('YYYY-MM-DD');
      setCustomChargeOnDate(formatedDate);
    },
    value: customChargeOnDate !== null ? moment(customChargeOnDate).toDate() : null
  })), /*#__PURE__*/React.createElement(Button, {
    variant: "actionButtonInvert",
    style: {
      width: '48px',
      height: '48px',
      marginLeft: '6px'
    },
    disabled: customChargeOnDate === null || customChargeOnDate === undefined,
    onClick: () => {
      setCustomChargeOnDate(null);
    },
    'custom-attribute': '858-property-utilities-setup-page'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "close"
  })), /*#__PURE__*/React.createElement(ExpandedTooltip, {
    placement: "top",
    title: t("Set the date to post the charge or credit — if you leave it blank, we’ll use date from property settings. If it's not set - we’ll use today’s date."),
    type: "grey"
  }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
    state: "info",
    type: "question"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    label: t('resident_account.memo'),
    value: memo,
    onChange: e => {
      if (e.target.value.length <= 255) setMemo(e.target.value);
    },
    variant: "outlined",
    multiline: true,
    type: "text",
    rows: 4
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.counter
  }, "(", memo.length, "/255)")), /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    label: t('resident_account.notes'),
    onChange: e => {
      if (e.target.value.length <= 255) setNote(e.target.value);
    },
    value: note,
    variant: "outlined",
    multiline: true,
    type: "text",
    rows: 4
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.counter
  }, "(", note.length, "/255)")), store.residenciesMultiActionStore.selectedDetails.findIndex(i => !!i.isEmail) !== -1 && postType !== 'recurring' ? /*#__PURE__*/React.createElement("div", {
    className: classes.notificationCheckbox
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      onChange: () => setNotifyResident(!notifyResident),
      value: notifyResident
    }),
    label: t('post_charge_modal.send_in-app_notifications')
  }))) : null), !isReview && /*#__PURE__*/React.createElement("div", {
    className: classes.modalContent
  }, /*#__PURE__*/React.createElement(Alert, {
    severity: "info",
    icon: false,
    size: "small",
    variant: "modal"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "light"
  }, t('post_charge_modal.confirm_posting', {
    amount: amount,
    chargeType: chargeType
  }))), /*#__PURE__*/React.createElement("div", null, store.residenciesMultiActionStore.selectedDetails.map(i => {
    var _store$homeDashboardS4;
    return /*#__PURE__*/React.createElement("div", {
      key: i.id,
      className: classes.unit
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h5",
      className: "".concat(i.isEmail ? '' : classes.noEmail)
    }, "Unit: ", i.number, " ", /*#__PURE__*/React.createElement("span", null, " - ", i.name), ' ', store.residenciesMultiActionStore.isSelectedIsMultiPropertyView && !store.residenciesMultiActionStore.isSelectedFromSingleProperty && /*#__PURE__*/React.createElement("span", null, ' ', "- (", (_store$homeDashboardS4 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS4 === void 0 || (_store$homeDashboardS4 = _store$homeDashboardS4.propertyDetails(i.propertyId).propertyInformation) === null || _store$homeDashboardS4 === void 0 || (_store$homeDashboardS4 = _store$homeDashboardS4.address) === null || _store$homeDashboardS4 === void 0 ? void 0 : _store$homeDashboardS4.addressString, ")")));
  }))), isReview && /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.modalFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: handleModalClose,
    'custom-attribute': '474-batch-post-charge-modal'
  }, t('buttons.cancel'))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    variant: "contained",
    onClick: () => setIsReview(false),
    disabled: !title.trim().length || amount.length === 0 || postType === 'recurring' && ends === 'OnNumberOfOccurrences' && !numberOfOccurrences,
    'custom-attribute': '475-batch-post-charge-modal'
  }, t('buttons.next')))))), !isReview && /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.modalFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: () => setIsReview(true),
    'custom-attribute': '476-batch-post-charge-modal'
  }, "Back to review")), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    variant: "contained",
    onClick: handleSubmit,
    'custom-attribute': '477-batch-post-charge-modal'
  }, t('buttons.submit')))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.transaction.customTransactionsAsync.inProgress || store.residencies.getResidencyBillingSettingsAsync.inProgress
  }));
});